/**
 * A change to one exercise in Buddy's proposal, drawn as the builder's exercise card (board U): the
 * day programming card over the progression statement. `features/ai-chat` asks for it through
 * `ProposalHost.renderExerciseChange`; the page composes it because the three are sibling features.
 * Its twin is `pages/ai-plan-builder/ui/ProposalExerciseChange.tsx`: change both together.
 */

import { useTranslation } from 'react-i18next';

import type { ExerciseChangeSlot } from '~/features/ai-chat';
import { ExerciseChangeCard } from '~/features/plan-day-programming';
import { RuleChange } from '~/features/plan-progression';

export function ProposalExerciseChange({ change }: { readonly change: ExerciseChangeSlot }) {
  const { t } = useTranslation();
  const { exercise, baseline } = change;
  return (
    <ExerciseChangeCard
      exercise={exercise}
      baseline={baseline}
      ordinal={change.ordinal}
      dayRestSeconds={change.dayRestSeconds}
      tag={change.tag}
      progression={
        <RuleChange
          exercise={exercise}
          previous={baseline.kind === 'previous' ? baseline.exercise : null}
          increments={change.increments}
          t={t}
        />
      }
    />
  );
}
